import React from "react"
import ReactDOM from "react-dom"

import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { UserProvider } from "./store/store"
import { Toaster } from "react-hot-toast"

// import i18n (needs to be bundled ;))
import "./i18n"

// Now the translations are loaded asynchronously, so make sure you wrap your
// app with a Suspense component to prevent this error: `Uncaught Error: App
// suspended while rendering, but no fallback UI was specified.`
import { Suspense } from "react"

import "./index.scss"

ReactDOM.render(
  <React.StrictMode>
    <UserProvider>
      <Suspense fallback="...is loading">
        <App />
        <Toaster position="bottom-right" />
      </Suspense>
    </UserProvider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
